import { useBackbone } from '@visikon/backbone/src';
import createSagaMiddleware from 'redux-saga';
import { applyMiddleware, compose, createStore, Store } from 'redux';
import { EnvironmentName } from '@visikon/backbone/src/env';
import { IState, reducer } from './reducers/reducer';
import sagas from './sagas/sagas';
import { authenticateFromStorage } from './actions/authActions';
import { isStartAuthOrSetUserRoute } from './sagas/utils';
import { initServiceWorkers } from './init';

export let reduxStore: Store<IState>;

export function useInitRedux() {
  const env = useBackbone((state) => state.env);

  // Setup sagas
  const sagaMiddleware = createSagaMiddleware();

  // Only attach Redux devtools in dev mode
  let composeEnhancers = compose;
  if (env === EnvironmentName.Local) {
    composeEnhancers = (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
  }

  reduxStore = createStore(reducer, composeEnhancers(applyMiddleware(sagaMiddleware)));
  sagaMiddleware.run(sagas);

  if (!isStartAuthOrSetUserRoute()) {
    reduxStore.dispatch(authenticateFromStorage()); // Load stuff from storage
  }

  initServiceWorkers(reduxStore);

  return reduxStore;
}
